import {
  useGetOne,
  useInput,
  useResourceContext,
  FieldTitle,
  type InputProps,
} from "ra-core";
import { useWatch } from "react-hook-form";
import {
  FormControl,
  FormError,
  FormField,
  FormLabel,
} from "@/components/admin/form";
import type { Deal } from "@/components/atomic-crm/types";
import { MemberMentionEditor } from "@/components/atomic-crm/tasks/MemberMentionEditor";

type TaskDescriptionMentionInputProps = {
  source?: string;
  label?: string | false;
  validate?: InputProps["validate"];
  className?: string;
  rows?: number;
  defaultDealId?: string | number | null;
  autoFocus?: boolean;
};

export const TaskDescriptionMentionInput = ({
  source = "text",
  label = "Description",
  className,
  rows = 4,
  defaultDealId,
  autoFocus,
  ...validateProps
}: TaskDescriptionMentionInputProps) => {
  const resource = useResourceContext();
  const { id, field, isRequired } = useInput({
    source,
    ...validateProps,
  });

  const dealId = useWatch({ name: "deal_id" }) ?? defaultDealId ?? null;

  const { data: deal } = useGetOne<Deal>(
    "deals",
    { id: dealId! },
    { enabled: dealId != null },
  );

  return (
    <FormField id={id} className={className} name={field.name}>
      {label !== false ? (
        <FormLabel>
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        </FormLabel>
      ) : null}
      <FormControl>
        <MemberMentionEditor
          id={id}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          rows={rows}
          autoFocus={autoFocus}
          placeholder="Describe the task…"
          teamMemberIds={
            Array.isArray(deal?.salesperson_ids) ? deal.salesperson_ids : []
          }
        />
      </FormControl>
      <FormError />
    </FormField>
  );
};
